import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ArtifactHealthApplicationComponent
  from './../Components/ArtifactHealthApplicationComponent';
import { fetchArtifactHealthApplicationStatuses, modal as modalActions }
  from './../actions';
import { getArtifactHealthPlatformApplication } from './../reducers';
import { artifactHealth as artifactHealthSelectors } from '../selectors';

const emptyApplication = {
  currentSupportedVersion: '',
  latestDataVersion: '',
  currentPublicVersion: '',
  axiomVersion: '',
  latestSupportedDate: '',
  lastGeneratedDate: '',
  tier: '',
  artifacts: [],
  missingArtifacts: []
};

export class ArtifactHealthApplicationContainer extends Component {
  static propTypes = {
    appSupportId: PropTypes.number.isRequired,
    platform: PropTypes.string.isRequired,
    applicationName: PropTypes.string.isRequired,
    fetchArtifactHealthApplicationStatuses: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.fetchArtifactHealthApplicationStatuses(
      this.props.appSupportId,
      this.props.platform,
      this.props.applicationName
    );
  }

  render() {
    return (
      <ArtifactHealthApplicationComponent
        {...this.props}
      />
    );
  }
}

export const mapStateToProps = (state, ownProps) => {
  const application = getArtifactHealthPlatformApplication(
    state,
    ownProps.platform,
    ownProps.applicationName
  );

  const props = application ?
    {
      ...application,
      status: ownProps.status,
      actions: artifactHealthSelectors.getArtifactHealthActions(state)(
        {
          id: application.id,
          appSupportId: application.appSupportId,
          platform: ownProps.platform,
          app: application,
          supportedVersion: application.currentSupportedVersion,
          diffVersion: application.latestDataVersion
        },
        0
      ),
    } :
    emptyApplication;
  return props;
};

export const mapDispatchToProps = (dispatch) => {
  return {
    fetchArtifactHealthApplicationStatuses: (id, platform, application) => {
      dispatch(fetchArtifactHealthApplicationStatuses(id, platform, application));
    },
    onClick: (applicationInfo) => {
      dispatch(modalActions.showVerifyArtifactApplicationModal(true, applicationInfo));
    },
    onActionButtonClick: (buttonAction) => { dispatch(buttonAction) ; }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactHealthApplicationContainer);


// WEBPACK FOOTER //
// src/Containers/ArtifactHealthApplicationContainer.jsx